import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enlng from "./locals/en.json";
import falng from "./locals/fa.json";
import pslng from "./locals/ps.json";

// Storage key constant (duplicated here to avoid circular dependency with language-context.jsx)
const LANGUAGE_STORAGE_KEY = "app-language";

// Get saved language from localStorage or default to 'en'
const getSavedLanguage = () => {
  if (typeof window !== "undefined") {
    const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (saved && ["en", "fa", "ps"].includes(saved)) {
      return saved;
    }
  }
  return "fa";
};

const savedLanguage = getSavedLanguage();

i18n.use(initReactI18next).init({
  debug: false,
  fallbackLng: "fa",
  lng: savedLanguage,
  resources: {
    en: { translation: enlng },
    fa: { translation: falng },
    ps: { translation: pslng },
  },
});

export default i18n;
